module.exports = __webpack_public_path__ + "93897aa950374b69ff0850c466b0e6ff.png";